<template>
  <div class="gd-check">
    <div class="gd-check-head">
      <fa-icon :icon="['fal', ready ? 'check-circle' : 'exclamation-triangle']"
               :class="ready ? 'gd-done-text' : 'gd-warn-text'"/>
      Checklist do convênio
      <span class="cnt" :class="{ready}">
        <template v-if="ready">Pronta para o lote</template>
        <template v-else>
          {{ pending.length }} {{ pending.length === 1 ? 'pendência' : 'pendências' }}
        </template>
      </span>
    </div>
    <ul>
      <li v-for="check in checks" :key="check.code"
          :class="liClass(check)" @click="focus(check)">
        <fa-icon :icon="['fal', iconOf(check)]"/>{{ check.message }}
      </li>
      <li class="ok" v-if="checks.length === 0">
        <fa-icon :icon="['fal', 'check-circle']"/>Nenhuma exigência para este plano
      </li>
    </ul>
    <div class="gd-check-note" v-if="!readonly">
      Clique numa pendência para ir ao campo.
    </div>
  </div>
</template>

<script>
export default {
  props: {
    checks: {
      type: Array,
      default: () => [],
    },
    ready: {
      type: Boolean,
      default: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    pending() {
      return this.checks.filter(check => !check.ok && check.level === 'block');
    },
  },
  methods: {
    liClass(check) {
      if (check.ok) return 'ok';
      return check.level === 'warn' ? 'warn' : 'bad';
    },
    iconOf(check) {
      if (check.ok) return 'check-circle';
      return check.level === 'warn' ? 'info-circle' : 'exclamation-triangle';
    },
    focus(check) {
      if (check.ok || this.readonly) return;
      this.$emit('focus', check.field);
    },
  },
};
</script>
